// Preserve amounts and all accounting metadata, changing category references
// on both the parent and any split portions (transactions or scheduled items).
export function remapCategoryReferences(record, fromId, toId) {
  if (!fromId || !toId || fromId === toId) return record;
  const parentMatches = record.categoryId === fromId;
  const splitMatches = record.splits?.some(split => split.categoryId === fromId);
  if (!parentMatches && !splitMatches) return record;
  return {
    ...record,
    ...(parentMatches ? { categoryId: toId } : {}),
    ...(splitMatches ? { splits: record.splits.map(split => split.categoryId === fromId ? { ...split, categoryId: toId } : split) } : {}),
  };
}

// Merge allocations without changing the total; safe to retry after a move.
export function remapCategoryAmounts(amounts, fromId, toId) {
  if (!amounts || fromId === toId || !Object.hasOwn(amounts, fromId)) return amounts;
  const next = { ...amounts, [toId]: Math.round(((Number(amounts[toId]) || 0) + (Number(amounts[fromId]) || 0)) * 100) / 100 };
  delete next[fromId];
  return next;
}
